

export default {
     summary_loan_estimates: "CleanFi has selected these various solutions for you as the lowest annual payment options\n" +
         "based on the first year of the term. By selecting each individual financing mechanism above,\n" +
         "other product options are available to you with other features sets that may be more\n" +
         "advantageous to your project or financing needs.",


     PACE: "Commercial Property Assessed Clean Energy (PACE) is a financing mechanism that enables long-\n" +
         "term funding for your resource efficiency or resiliency improvement project. Individual state\n" +
         "government programs encourage funders to provide long-term financing by securing their risk\n" +
         "via a property tax assessment during the repayment of the funds. The products below will\n" +
         "differ in features such as program fees, or pre-payment penalty, underwriting criteria or other\n" +
         "features, listed under each annual payment recap. In all cases, all applicable tax benefits stay\n" +
         "with the building owner.",


     "PACE PPA": `A "PACE PPA" is used when the property owner cannot take the substantial tax benefits associated with a 
     renewable energy investment or (in the case of non-profits) does not want to file for Direct Pay. In that case, a third party buys a 
     discounted value of the DirectPay/ITC by investing into the project.  The property owner finances the balance of the project cost, 
     per the proposals below.  For more information on this mechanism, contact CleanFi via 877-301-7800, or support@cleanfi.com.`,

     "Capital Lease": `A Capital Lease differs from a Loan in the way it is treated on the books: operating cost vs liability.  
     But a Capital Lease is very much like a Term Loan in all other ways, in that it is for a Fixed Term (no pre-payment 
        except for any pay-down allowance in a specific product's Notes below), and all tax benefits accrue to the borrower.  
        For more information, see https://blog.cleanfi.com/what-is-a-capital-lease/ `,


     "Loan": "Products presented here are typically amortized loans from specialty or mission-oriented\n" +
         "funders, community development organizations, or credit unions. All applicable tax benefits\n" +
         "stay with the borrower.",


     "PPA": "A PPA (Power Purchase Agreement) is a long-term contract between a power-plant investor (solar or other)  " +
         "and an “off-taker” (the exclusive consumer of the electricity from said power plant).  The off-taker agrees " +
         "to buy 100% of the power plant’s production from the investor for a set term (typically 20 or 25 years) at a pre-set " +
         "‘per-kilowatt hour’ pricing schedule.  Typically, all maintenance obligations lie with the investor/owner of the power plant " +
         "for the duration of the term."


}